"use strict";
angular.module("planCommandMonitorSelectedTopicModule", [])
    .controller('planCommandMonitorSelectedTopicCtrl', ['$scope', 'trsHttpService', '$q', '$stateParams', 'planCommandMonitorService', '$state', 'modalDialog','$rootScope',
        function($scope, trsHttpService, $q, $stateParams, planCommandMonitorService, $state, modalDialog,$rootScope) {
            initStatus();
            initData();
            /**
             * [initData description:初始化数据]
             */
            function initData() {
                requestData();

            }
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status = {
                    router: {
                        "编前选题管理": {
                            router: 'front.planningresource.commandMonitor.beforeselecttopic'
                        },
                        "一次舆情管理": {
                            router: 'front.planningresource.commandMonitor.oncepublicopinion'
                        },
                        "自定义功能管理": {
                            router: 'front.planningresource.commandMonitor.customfunctionmanage'
                        },
                        "事件分析管理": {
                            router: 'front.planningresource.commandMonitor.manuscriptanalysis'
                        },
                        "新疆舆情管理": {
                            router: 'front.planningresource.commandMonitor.publicopinionmgrzj.functionlist'
                        },
                        "地图调度管理": {
                            router: 'front.planningresource.commandMonitor.mapscheduling.manage'
                        },
                        "客户端push管理": {
                            router: 'front.planningresource.commandMonitor.clientPushManagement'
                        }
                    }
                };
                $scope.data = {};
            }
            /*
             *[requestData description:获取数据]
             */
            function requestData() {
                var params = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'getaddfunclist',
                    "sceneId": $stateParams.sceneid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data = data.listr[0]; //将获得的数据赋值到初始定义的data中
                });

            }
            /**
             * [addSelectedTopic description:编前选题添加按钮触发函数]
             */
            $scope.addSelectedTopic = function() {
                $scope.addParams = {
                    "serviceid": 'mlf_bigdatascreen',
                    "methodname": 'queryDataFromBigScreen',
                    "modalname": 'addFuncMgr',
                    "method": 'addFuncOther',
                    "sceneid": $stateParams.sceneid,
                    "addFlag": ($stateParams.addflg === "true") ? 1 : 0,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.addParams, 'post').then(function(data) {
                    if (data.mapResult.status === "SUCCESS") {
                        $rootScope.$broadcast('changeCommandList', true);
                        modalDialog.alertType("", "添加成功", "success", true, function() {
                                var router = $scope.status.router[$scope.data.sceneName];
                                $state.go(router.router, {}, { reload: "front.planningresource" });
                            },
                            function() {
                                requestData();
                            }, "", "留在当前页", "立即查看");
                    } else {
                        modalDialog.alertType("", "添加失败请重新更新", "error", "confirm");
                    }
                });
            };
        }
    ]);